import http from '../api/http'

export default {
  all: () => http.get('/customers/all'),
  exists: (email) => http.get('/customers/exists', { params: { email } }),
  pagination: (conditions, pagination) => http.get('/customers/pagination', { params: { conditions, pagination } }),
  save: (customer) => http.post('/customers/save', customer),
  search: (query) => http.get('/customers/search', { params: { query } })
}



// WEBPACK FOOTER //
// ./src/services/customers.js